import useDocumentTitle from '../hooks/useDocument';
import Header from '../components/header';
import Hero from '../components/hero';
import Services from '../components/service';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function HomeView() {
  useDocumentTitle('Home-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Hero />
      <Services />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default HomeView;
